export default __webpack_public_path__ + "551f36b020b3b785c77c8242d4d9ea17.svg";